<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('mentora_time_of_request_detail')"
                :isFilter="false"/>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('mentora_time_of_request_detail')"
                      :isFilter="false"/>
      </template>
      <div>
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <h6 class="text-uppercase mb-0">
                {{ toUpperCase('application_information') }}
              </h6>
            </div>
          </div>
          <div class="col-12">
            <b-row>
              <div class="col-12">
                <div class="border rounded p-4 mb-3 h-100">
                  <div class="mb-4">
                    <h6 class="text-uppercase mb-0">
                      {{ $t('student_information').toUpper() }}
                    </h6>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('student_id')">
                        <span>
                          {{ leaveAbsenceData.student_number }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('full_name')">
                        <span>
                          {{ leaveAbsenceData.name?leaveAbsenceData.name:'-' + ' ' + leaveAbsenceData.surname }}
                        </span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('status')">
                        <span>
                          {{ leaveAbsenceData.status_name }}
                        </span>
                      </b-form-group>
                    </div>
<!--                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">-->
<!--                      <b-form-group :label="$t('last_approve_date')">-->
<!--                        <span>-->
<!--                          {{ leaveAbsenceData.last_approve_date }}-->
<!--                        </span>-->
<!--                      </b-form-group>-->
<!--                    </div>-->
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('selected_sessions')">
                        <div v-for="(item,index) in leaveAbsenceData.selected_sessions" :key="index"
                             class="d-flex flex-column">
                          <span>{{ index + 1 }} -  {{ item.name }} </span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                </div>
              </div>
            </b-row>
            <div class="border rounded p-4 mb-3 mt-4 w-100">
              <ValidationObserver ref="formObserver">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <ValidationProvider name="attended_all_classes_after_prev_time_off"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                      <b-form-group :label="$t('attended_all_classes_after_prev_time_off')">
                        <yes-no-selectbox
                            :disabled="!checkPermission('studenttimeoffrequest_update')"
                            v-model="leaveAbsenceData.attended_all_classes_after_prev_time_off"
                            :validate-error="errors[0]"
                        />
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <ValidationProvider name="eligible_duration"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                      <b-form-group :label="$t('eligible_duration')">
                        <multi-selectbox
                            :multiple="false"
                            :disabled="!checkPermission('studenttimeoffrequest_update')"
                            :options="[{value:4, text:'4 week'},{value:8, text:'8 week'},{value:12, text:'12 week'}]"
                            v-model="leaveAbsenceData.eligible_duration"
                            :validate-error="errors[0]"
                        />
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <ValidationProvider name="good_standing"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                      <b-form-group :label="$t('good_standing')">
                        <yes-no-selectbox
                            :disabled="!checkPermission('studenttimeoffrequest_update')"
                            v-model="leaveAbsenceData.good_standing"
                            :validate-error="errors[0]"

                        />
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <ValidationProvider name="on_probation"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                      <b-form-group :label="$t('on_probation')">
                        <yes-no-selectbox
                            :disabled="!checkPermission('studenttimeoffrequest_update')"
                            v-model="leaveAbsenceData.on_probation"
                            :validate-error="errors[0]"

                        />
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <b-col cols="12" class="text-center mt-3"
                       v-if="['MA'].includes(userRoles) && !['approved'].includes(leaveAbsenceData.status)">
                  <LoadingButton
                      :loading="isLoading"
                      text="Save"
                      v-if="checkPermission('studenttimeoffrequest_update') && selectedActiveStep"
                      @click="update"/>
                </b-col>
              </ValidationObserver>
            </div>
          </div>
        </div>
        <div v-if="selectedActiveStep">
          <h6 class="text-uppercase mb-4">{{ $t('approval_procedures').toUpper() }}</h6>
          <ValidationObserver ref="updateForm">
            <div >
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                  <b-form-group :label="$t('status')">
                    <multi-selectbox
                        :multiple="false"
                        v-model="updateStep.status"
                                   :options="statusOptions"
                                   :validate-error="errors[0]"
                    />
                  </b-form-group>
                </ValidationProvider>
              </div>

                <div class="col-12 col-md-6 col-lg-6 col-xl-6" v-if="['declined'].includes(updateStep.status)">
                    <ValidationProvider name="reason" :rules="['declined'].includes(updateStep.status)?'required':''" v-slot="{valid, errors}">
                        <b-form-group :label="$t('reason')">
                            <b-form-textarea v-model="updateStep.reason"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </div>
          </ValidationObserver>
          <b-form-group>
            <LoadingButton
                :loading="isLoading"
                :text="$t('approve')"
                @click="stepUpdate"/>
          </b-form-group>
        </div>
        <div v-if="steps">
          <b-table :empty-text="$t('there_are_no_records')" bordered striped responsive :items="steps"
                   :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'approvers', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' }
                        ]" show-empty sort-by="rank" class="mb-3 table-dropdown no-scrollbar border rounded">
            <template #cell(approvers)="data">
                            <span v-for="(approver, key) in data.item.approvers" :key="key">
                                {{ approver.explanation }} <br>
                            </span>
            </template>
            <template #cell(approved)="data">
                            <span v-for="(approver, key) in data.item.approved" :key="key">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
            </template>
              <template #cell(updated_at)="data">
                  {{formatDate(data.item.updated_at)}}
              </template>
            <template #cell(status)="data">
              {{ data.item.status_name }}
            </template>
          </b-table>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import {ValidationProvider, ValidationObserver} from "vee-validate"
import MentoraTimeOffRequestFormServices from "@/services/MentoraTimeOffRequestFormServices";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import moment from "moment";

export default {
  components: {
    YesNoSelectbox,
    LoadingButton,
    MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {},
      updateStep: {
        status: null
      },
      leaveAbsenceData: {
        attended_all_classes_after_prev_time_off: null,
        eligible_duration: null,
        good_standing: null,
        on_probation: null,
        amount_due: null
      },
      step: {},
      steps: [],
      statuses: {},
      statusOptions: [
        {value: null, text: 'select'},
        {value: 'approved', text: this.$t('approved')},
        {value: 'declined', text: this.$t('declined')},
      ],
      isLoading: false,
    }
  },

  metaInfo() {
    return {
      title: this.$t('mentora_time_of_request_detail')
    }
  },
  computed: {
    userRoles() {
      return this.$store.getters['auth/getActiveRole']
    },
    selectedActiveStep() {

      if (this.steps && this.steps.length > 0) {
        const activeStep = this.steps.filter((item) => item.active)
        return activeStep[0]?.approvers?.[0].name === this.userRoles
      } else {
        return false
      }
    }
  },
  created() {
    this.getMentoraTimeOfRequest();
  },
  methods: {
    getMentoraTimeOfRequest() {
      MentoraTimeOffRequestFormServices.show(this.$route.params.id)
          .then(response => {
            this.leaveAbsenceData = response.data.data;
            this.leaveAbsenceData.amount_due = Number(response.data.data.amount_due)
            this.leaveAbsenceData.eligible_duration = Number(response.data.data.eligible_duration)
            this.step = this.leaveAbsenceData.step == null ? {} : this.leaveAbsenceData.step;
            this.steps = this.leaveAbsenceData.steps;
          })
          .catch(e => {
            this.$toast.error(e.data.message)
          })

    },
    async update() {
      const isValid = await this.$refs.formObserver.validate();
      if (isValid) {
        this.$swal.fire({
          title: this.$t('warning'),
          text: this.$t('leave_of_absence_statement'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
        }).then((result) => {
          this.isLoading = true
          if (result.isConfirmed) {
            this.leaveAbsenceData.attended_all_classes_after_prev_time_off = this.leaveAbsenceData.attended_all_classes_after_prev_time_off === 'Yes' ? 1 : 0
            this.leaveAbsenceData.good_standing = this.leaveAbsenceData.good_standing === 'Yes' ? 1 : 0
            this.leaveAbsenceData.on_probation = this.leaveAbsenceData.on_probation === 'Yes' ? 1 : 0
              MentoraTimeOffRequestFormServices.update(this.$route.params.id, this.leaveAbsenceData)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.getMentoraTimeOfRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                }).finally(this.isLoading = false);
          }
        })
      }
    },
    async stepUpdate() {
      const isValid = await this.$refs.updateForm.validate();
      if (isValid) {
        this.$swal.fire({
          title: this.$t('warning'),
          text: this.$t('leave_of_absence_statement'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
        }).then((result) => {
          this.isLoading = true
          if (result.isConfirmed) {
            let data = {
              status: this.updateStep.status,
            }
              if (['declined'].includes(this.updateStep.status)){
                  data.reason = this.updateStep.reason
              }
            const activeStep = this.steps.filter((item) => item.active)
            MentoraTimeOffRequestFormServices.updateStep(activeStep[0].id, data)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.getMentoraTimeOfRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                }).finally(this.isLoading = false);
          }
        })
      }
    },
      formatDate(date){
        return moment(date).format('MM/DD/YYYY HH:mm')
      }
  },
    }
</script>
